const Footer = () => {
    return (
       <div className="dashboard_footer">
         Footer
       </div>
    );
   }
   
export default Footer;